var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"account"}},[_c('div',{class:_vm.isMobile ? 'active' : '',attrs:{"id":"content_page"}},[_c('account-content')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }